
export const contactPrefLabels = {
	email: 'Email',
	primary_phone: 'Phone',
	cell_phone: 'Cell Phone',
}